/* eslint-disable max-len */
/* eslint-disable max-lines */
if (!window.cloudI18n) {
  window.cloudI18n = {};
}
window.cloudI18n.en = {
  ' as part of my care journey.': '',
  ' more characters to meet the recommended minimum': '',
  ', and I consent to the ': '',
  ', the ': '',
  '1 year old': '',
  'A default appointment reason has been generated but you can still change it. It will be displayed in the participants calendars, in their notifications and in the video call.': '',
  'A link to the payment page will also be sent': '',
  'A user whose calendar is selected does not have a profile that allows delegated access. Please contact a user manager.': '',
  'A valid email address is required for appointments with payment.': '',
  Accept: '',
  Accepted: '',
  'Access code': '',
  Actions: '',
  Activate: '',
  'Activate payment': '',
  'Active principle': '',
  Acts: '',
  'Acts section': '',
  Add: '',
  'Add ': '',
  'Add a rate': '',
  'Add all character types (uppercase, lowercase, numbers, special characters)': '',
  'Add email address': '',
  Address: '',
  'Administration route': '',
  Age: '',
  'Air SMUR Teams': '',
  'Al (VNI)': '',
  'All your appointment settings are displayed. Click on any of them in order to change it.': '',
  'Already have an account?': '',
  'Ambient air': '',
  Amount: '',
  'An account already exists': '',
  'An appointment is already set for this time slot.': '',
  'An appointment is in progress': '',
  'An error occured while fetching options. Please try again later.': '',
  'An error occurred while fetching fees. Please try again later.': '',
  'An error occurred while fetching recordings. Please contact Parsys support.': '',
  'An error occurred while processing your request.': '',
  'An error occurred. Please retry later.': '',
  Anonymous: '',
  'Anonymous patient': '',
  'Anything left to do?': '',
  Appointment: '',
  'Appointment created.': '',
  'Appointment duration as set by the practitioner': '',
  'Appointment duration predefined by the practitioner': '',
  'Appointment durations': '',
  'Appointment filters': '',
  'Appointment types': '',
  Appt: '',
  'Are you sure you want to change the appointment form? The fields will be reset.': '',
  'Are you sure you want to delete this medicine?': '',
  'Are you sure you want to delete this rate? This action cannot be undone.': '',
  Attachments: '',
  Attributed: '',
  'Availabilities could not be created on the following dates because they overlap with existing ones': '',
  'Availabilities created.': '',
  Availability: '',
  'Availability cannot be changed or moved there because it would overlap with another one.': '',
  Available: '',
  'Awaiting capture': '',
  'Awaiting payment': '',
  BMI: '',
  Back: '',
  Bandwidth: '',
  'Be more specific to narrow down the search': '',
  'Bill later': '',
  'Bill now': '',
  Billing: '',
  Birthdate: '',
  'Blood pressure': '',
  'Blood sugar': '',
  Bold: '',
  'Book an appointment': '',
  'Booth Teleconsultation': '',
  'Booth teleconsultation': '',
  'Born on': '',
  'Browse other weeks': '',
  'Browser not supported.': '',
  'CV (VI)': '',
  'Calendar controls': '',
  'Calendar of': '',
  'Call Information': '',
  'Caller identity': '',
  Cancel: '',
  'Cancel appointment': '',
  Cancelled: '',
  'Change Appointment Form': '',
  'Change history': '',
  'Charge a fee': '',
  'Check my Equipment': '',
  'Check that you can manage the practitioner\u2019s calendar': '',
  'Choose a fee': '',
  'Choose teleconsultation mode': '',
  Classification: '',
  'Click a practitioner\u2019s name to edit their calendar.': '',
  'Click on a mobile resource name to modify its calendar.': '',
  'Click on the "desired slot" field and chose the date and time at which you want the appointment to be set.': '',
  'Clinical Examination': '',
  'Clinical interpretation of the ECG report may be affected by the filter settings.': '',
  Close: '',
  Closed: '',
  'Color code': '',
  Columns: '',
  'Commercial name': '',
  Conditioning: '',
  Confirm: '',
  'Confirm appointment': '',
  'Confirm cancellation': '',
  'Confirm password': '',
  'Confirm the creation': '',
  Confirmed: '',
  'Consultation fee predefined by the practitioner': '',
  Consultations: '',
  'Contact phone number': '',
  Context: '',
  Copied: '',
  'Copy patient link': '',
  'Copy practitioner link': '',
  'Corresponds to a functional or technical test. Do not use for medical diagnosis.': '',
  Country: '',
  Create: '',
  'Create a new location': '',
  'Create a patient': '',
  'Create a patient if they do not already exist': '',
  'Create my patient account': '',
  'Create the appointment': '',
  Creation: '',
  'Custom appointment duration': '',
  Cutaneous: '',
  DIA: '',
  Date: '',
  Day: '',
  Decline: '',
  Default: '',
  Delete: '',
  'Delete rate': '',
  Description: '',
  'Desired slot': '',
  'Display details': '',
  'Document added': '',
  Download: '',
  'Draft saved locally.': '',
  'Drug added': '',
  'Drug deleted': '',
  Duration: '',
  ECG: '',
  EVA: '',
  Edit: '',
  'Edit email address': '',
  'Edit location': '',
  'Edit rate': '',
  'Edit the appointment reason': '',
  'Edit the practitioner\u2019s calendar': '',
  'Edit the resource\u2019s calendar': '',
  'Email addresses': '',
  End: '',
  'End date': '',
  'End of recurrence': '',
  'End time': '',
  'Enter a practitioner\u2019s name (minimum 3 characters)': '',
  'Enter at least 3 characters to begin searching': '',
  'Enter the patient\u2019s name (minimum 3 characters)': '',
  'Enter the practitioner\u2019s name (minimum 3 characters)': '',
  Erase: '',
  'Error adding drug. Please try again.': '',
  'Error adding rate. Please try again.': '',
  'Error deleting drug. Please try again.': '',
  'Error deleting rate. Please try again.': '',
  'Error editing drug. Please try again.': '',
  'Error editing rate. Please try again.': '',
  EtCO2: '',
  'EtCO2 (VI)': '',
  Exams: '',
  Excellent: '',
  Expired: '',
  'Extend chat window': '',
  'Facility List': '',
  Fair: '',
  'FiO2 (O2)': '',
  'FiO2 (VI)': '',
  'FiO2 (VNI)': '',
  Filter: '',
  'Filter by location': '',
  Filters: '',
  'Filters applied': '',
  'Find a consultation location': '',
  'Find an expert': '',
  Finish: '',
  'First call date': '',
  'First name': '',
  'Flight No': '',
  'Flow (O2)': '',
  'Flow rate': '',
  'For readability\u2019s sake, only up to 5 simultaneously.': '',
  Fullscreen: '',
  'Functional or technical test': '',
  Gender: '',
  Glasgow: '',
  Glucose: '',
  Good: '',
  'Ground SMUR Teams': '',
  'Heading large': '',
  'Heading medium': '',
  'Heading small': '',
  'Heart rate': '',
  Help: '',
  'Hide details': '',
  History: '',
  'How can I add a practitioner\u2019s calendar to the multiple view?': '',
  'How many calendar can I view at the same time?': '',
  'How to activate payment?': '',
  'How to find a slot?': '',
  'How to find practitioners?': '',
  'How to find the patient?': '',
  'How to find the practitioner?': '',
  'How to find the requesting practitioner?': '',
  'How to specify a slot?': '',
  Hémocue: '',
  'I accept the ': '',
  ID: '',
  'IP (VI)': '',
  IVD: '',
  IVL: '',
  IVSE: '',
  'If no location is available for appointments, it is necessary to add availability to the mobile resource calendar.': '',
  'If the "Next" button is not disabled, it means that some slots may be available in the upcoming weeks.': '',
  'If the patient has never been registered, you need to open the creation form by clicking on the "Create a patient" button and fill it up. Then you will be able to finish the last steps of the appointment form.': '',
  'If the practitioner has set up billing, the payment is then automatically activated with the amount they have predefined. However, you can deactivate the payment if the patient is reimbursed 100%, and modify the amount if necessary.': '',
  'If they do not have disabled them, invited practitioners will receive notifications upon appointment creation, cancellation, or some time before its starts, as a reminder.': '',
  'In order for the search to give results, you need to supply at least three consecutive characters contained in the patient\u2019s name.': '',
  'In order for the search to give results, you need to supply at least three consecutive characters contained in the practitioner\u2019s name.': '',
  'In order to book an appointment, you need to select a user that delegated their calendar management to you in their profile settings. They will be set as the requester practitioner from whom the appointment originated.': '',
  Inhalation: '',
  'Initial CCC': '',
  Intervention: '',
  'Intervention List': '',
  'Intervention Number': '',
  Interventions: '',
  Interview: '',
  Intramuscular: '',
  Intranasal: '',
  Intrarectal: '',
  'Invalid configuration': '',
  'Invalid email address': '',
  'Invalid phone number': '',
  Italic: '',
  'Join as patient': '',
  'Join as practitioner': '',
  LTC: '',
  Label: '',
  'Last CCC': '',
  'Last Message': '',
  'Last event': '',
  'Last known lat/lng ': '',
  'Last name': '',
  'Last updated ': '',
  'Last updated on': '',
  'Let the notifications be sent': '',
  Loading: '',
  'Loading...': '',
  Location: '',
  'Location selection': '',
  Logout: '',
  MAP: '',
  'Make sure a practitioner is available': '',
  'Make sure some practitioners are available': '',
  'Make sure that the practitioner delegated their calendar management to you in their profile settings.': '',
  'Map Legend': '',
  Medcapture: '',
  'Medical consultation between the patient, possibly assisted by a health professional, and a practitioner.': '',
  'Medical developments': '',
  'Mobil units': '',
  'Modify the patient contact information': '',
  Month: '',
  'Multiple view': '',
  'My calendar': '',
  NIBP: '',
  Name: '',
  'New Appointment': '',
  'New data is available': '',
  'Next appointment': '',
  'Next slot on': '',
  No: '',
  'No available facilities': '',
  'No available slots.': '',
  'No expert is available for this slot or this type of appointment.': '',
  'No expert matches your search.': '',
  'No filter applied': '',
  'No intervention in progress': '',
  'No location is available for scheduling appointments.': '',
  'No locations are available': '',
  'No locations available?': '',
  'No match found.': '',
  'No options available': '',
  'No other expert is available for this slot or this type of appointment.': '',
  'No password': '',
  'No past appointment.': '',
  'No patient matches your search.': '',
  'No practitioner has delegated their calendar to you.': '',
  'No recordings found for the selected date range. Try a wider search.': '',
  'No slot available this week.': '',
  'No slots available.': '',
  'No teleconsultation modes available.': '',
  'No therapeutics found': '',
  'No upcoming appointment.': '',
  'No workflows available': '',
  'Non-telemedicine appointments (in-person consultation, home visit, etc.)': '',
  Normal: '',
  'Not Attributed': '',
  'Not authorized': '',
  Notes: '',
  'Notify external participants': '',
  'Notify the patient': '',
  OL: '',
  Ok: '',
  'Once you are satisfied with all the options you set, create the appointment by clicking the "Finish" button. Invited practitioners that did not delegate their calendar to you will have to approve the appointment.': '',
  'Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching patients and find the one you are looking for.': '',
  'Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching practitioners and find the one you are looking for.': '',
  'Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching practitioners and find the ones you are looking for.': '',
  'Only the practitioners who are available for the appointment type you have chosen are listed here. If they delegated their calendar to you, you are able to edit their availabilities.': '',
  'Only the practitioners who have some availabilities for the appointment type you have specified are listed here. If they delegated their calendar to you, you are able to edit their availabilities.': '',
  'Open in new tab': '',
  Origin: '',
  'Other (in-person, etc.)': '',
  'Other (tele-expertise, face-to-face, ...)': '',
  'Other surveillance data': '',
  Oximetry: '',
  PDF: '',
  'PEEP (VI)': '',
  'PEEP (VNI)': '',
  PR: '',
  'Pacemaker detected. The automatic measurements displayed may be less accurate.': '',
  'Parsys ID': '',
  Password: '',
  'Password meets requirements': '',
  'Password too short': '',
  'Passwords do not match': '',
  Past: '',
  Patient: '',
  'Patient created.': '',
  'Patient record': '',
  'Patient updated.': '',
  'Patient was not modified, please try again.': '',
  'Pay later': '',
  Payment: '',
  'Payment failed.': '',
  'Payment selection': '',
  'Pending appointment': '',
  'Per Os': '',
  'Personal reminder': '',
  'Phone number': '',
  Photo: '',
  'Pick a date and time': '',
  Planning: '',
  'Please contact your administrator or download a compatible browser.': '',
  'Please enter a valid email address.': '',
  'Please select the location where the meeting will take place.': '',
  Practitioners: '',
  Prescription: '',
  'Press "Enter" to validate email addresses.': '',
  'Primary Specialty': '',
  'Privacy Policy': '',
  'Professional-to-professional act, patient not present.': '',
  Project: '',
  Proposed: '',
  Pulse: '',
  'Quantity per volume': '',
  RF: '',
  'RF (VI)': '',
  'Reason (Required)': '',
  'Receiving Facility': '',
  Recourse: '',
  Recurrence: '',
  Redo: '',
  'Reduce chat window': '',
  Reminder: '',
  'Requester expert': '',
  'Required expert': '',
  'Reset current center and zoom': '',
  'Respiratory rate': '',
  'Room ID': '',
  Route: '',
  'SAMU SMUR': '',
  SMUR: '',
  SYS: '',
  SaO2: '',
  'Sampling rate': '',
  Save: '',
  Scale: '',
  Score: '',
  Scores: '',
  'Sea SMUR Teams': '',
  Search: '',
  'Search for a therapeutic to add it': '',
  'Search...': '',
  'Searching...': '',
  'Seat No/Staff No': '',
  'Select a location': '',
  'Select a patient': '',
  'Select a practitioner': '',
  'Select a slot': '',
  'Select an appointment type': '',
  'Select practitioners': '',
  'Select/Deselect all': '',
  'Select/Unselect all': '',
  Send: '',
  'Serial Number': '',
  'Set as default': '',
  'Set the appointment duration': '',
  'Severe Trauma': '',
  'Shared notes': '',
  'Show more slots': '',
  'Sign in': '',
  Site: '',
  Solute: '',
  'Some practitioners might only be available for other time slots or appointment types.': '',
  SpCO: '',
  SpO2: '',
  Spirometry: '',
  Start: '',
  'Start date': '',
  'Start time': '',
  Station: '',
  Status: '',
  Submit: '',
  Summary: '',
  Support: '',
  Surveillance: '',
  'Synchronization in progress...': '',
  'Teams and facilities': '',
  'Tele-expertise / Tele-staff / Multidisciplinary team meeting': '',
  Teleconsultation: '',
  Telestaff: '',
  Temperature: '',
  Tenant: '',
  Tenants: '',
  'Terms and Conditions': '',
  'Terms of Service': '',
  Test: '',
  'Thank you for your payment!': '',
  'That user will be added to the list of visible calendars and the first one you have ticked (in a chronological order) will be hidden from the multiple view.': '',
  'The cancellation of an appointment is final. Are you sure you want to cancel this appointment?': '',
  'The duration displayed in blue is the one defined by the practitioner. However, you can change this duration by selecting from the drop-down menu of the "Appointment duration" field. The selected duration will be used to find the slots in the practitioner\u2019s calendar.': '',
  'The endowment list is empty. Add therapies to fill the list.': '',
  'The following leads include a saturated signal: ': '',
  'The patient already exists.': '',
  'The patient videoconference link was successfully copied to your clipboard.': '',
  'The practitioner videoconference link was successfully copied to your clipboard.': '',
  "The practitioner's RPPS number must be set on both Parsys and Premiocare systems to make an appointment.": '',
  'The slot that you choose will be the date and time at which the appointment will be set in the participants calendars.': '',
  'The type of appointment defines the kind of participants that you will be able to invite and how the data gathered during the appointment will be processed.': '',
  'Therapeutics section': '',
  'There are no resource to display.': '',
  'There was an error while updating your settings. Please try again later or contact your administrator.': '',
  'This availability has been shared on other environments to which you do not have access. Please contact Parsys support.': '',
  'This consultation can no longer be paid. It may have been cancelled.': '',
  'This consultation has already been paid.': '',
  'This enumerates all the practitioners who have delegated their calendar management to you.': '',
  'This is the only available appointment type for the selected practitioner': '',
  'This patient is missing mandatory fields for Premiocare appointments:': '',
  'This practitioner is not available for any type of appointment.': '',
  "This practitioner's RPPS number is not set in Parsys.": '',
  'This teleconsultation mode is required for the selected practitioner': '',
  Today: '',
  Transdermal: '',
  'Try another time slot or appointment type': '',
  Type: '',
  'Type at least 3 characters to start your search.': '',
  'Type at least three letters to search': '',
  'Type of residence': '',
  UL: '',
  Unavailable: '',
  Underline: '',
  Undo: '',
  Unread: '',
  Upcoming: '',
  'Upload failed': '',
  Urgency: '',
  'Use ctrl+mouse wheel to zoom.': '',
  User: '',
  'User Profile': '',
  'User settings': '',
  Validate: '',
  Validated: '',
  'Very weak': '',
  Video: '',
  'Video consultation': '',
  Videoconference: '',
  'Videoconference room': '',
  'View the agenda of several practitioners': '',
  'Vitals section': '',
  'Warning: your browser seems to be outdated. Please consider updating to a more recent browser.': '',
  Weak: '',
  Week: '',
  'Weekly recurrence': '',
  'What happens if I select a 6th practitioner?': '',
  'When moving your mouse over a practitioner\u2019s avatar or initials, you can tick a checkbox to add their events to the multiple view. Un-tick it to hide them.': '',
  'Which type should you choose?': '',
  'Who are the listed users?': '',
  Yes: '',
  'You are able to book an appointment for any user that delegated their calendar management to you in their profile settings.': '',
  'You are able to invite any user to the appointment. Those who did not delegate their calendar management to you in their profile settings will have to approve the appointments.': '',
  'You are able to select any available user for the appointment. If they did not delegate their calendar management to you in their profile settings, they will have to approve the appointment.': '',
  'You can check and edit the patient contact information so that they can receive (or not) a notification and a reminder for the appointment you are setting. To do so, just click the "Edit email address" button.': '',
  'You can choose the slot you want in order to find a practitioner that is available at that time.': '',
  'You can only display 5 agendas at a time. Please deselect one.': '',
  'You can select another practitioner in the list on the left panel': '',
  'You can set the duration you want by selecting it in the dropdown menu of the "appointment duration" field. It will be used to find slots in the practitioner\u2019s schedule. Then click "Confirm".': '',
  'You can\u2019t delete or modify an availability when an active appointment is booked on it. Please edit your appointments before modifying the availability.': '',
  'You must accept the terms to continue': '',
  'You will be redirected to Stripe in a few seconds...': '',
  'Your account has been created successfully. Please check your email to verify your address and complete your account setup.': '',
  'Your actions during the procedure will appear here.': '',
  'Your browser (or its version) isn\u2019t compatible with the telemedecine solution.': '',
  'Your rates': '',
  'Your search doesn\u2019t match any practitioner.': '',
  'Your settings have been updated.': '',
  at: '',
  calculating: '',
  d: 'day(s)',
  day: 'day(s)',
  'day and': '',
  'days and': '',
  done: '',
  draft: '',
  hour: '',
  in: '',
  link: '',
  m: 'month(s)',
  measures: '',
  min: '',
  minutes: '',
  'modified By': '',
  month: 'month(s)',
  or: '',
  overdue: '',
  'practice of telemedicine': '',
  saved: '',
  'uploads in progress': '',
  week: 'week(s)',
  'will not receive an invitation nor a reminder by email.': '',
  'will receive an invitation and a reminder by email.': '',
  y: 'year(s)',
  year: 'year(s)',
  'years old': '',
};
